import Trans from 'next-translate/Trans'

const FomoMessage: React.FC<{ userViews: number }> = ({ userViews }) => (
  <Trans
    components={[<strong key="0" />]}
    i18nKey={userViews > 1 ? 'listing-detail:fomo_message_people' : 'listing-detail:fomo_message_person'}
    values={{ userViews }}
  />
)

export default FomoMessage
